import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import HttpClient from "src/http/http-client";
import { IServerModel } from "src/model";
import { ServiceInjectable } from "src/utils/services";

/**
 * 用户类
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class SkcServerService extends ServiceBase
{
    /**
     * 获取列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async skcServerPageList(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.skcServerPageList({ data });
        return response;
    }

    /**
     * 获取列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getSkcServer(id: number): Promise<IHttpResponse>
     {
         let response = await this.apis.getSkcServer({ urlPath: { id } });
         return response;
     }
    
}